

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomultistepsignupmodel', ['squid']).factory('$MultistepSignupModel', function ($Model) {
        return $Model.extend('MultistepSignupModel', {});
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/index.js
// module id = ./components/xo-guest-components/src/multistep-signup/index.js
// module chunks = 1